/** Clio custom-field display names used by the picklist API. */
export const CLIO_CUSTOM_FIELD_NAMES = {
  raa: "Responsible Associate Atty (RAA)",
  ap: "Assigned Paralegal (AP)",
  sma: "Senior Managing Atty (SMA)",
  sa: "Supporting Atty (SA)",
} as const;

export type ClioRoleField = keyof typeof CLIO_CUSTOM_FIELD_NAMES;

export const CLIO_ROLE_LABELS: Record<ClioRoleField, string> = {
  raa: "RAA",
  ap: "AP",
  sma: "SMA",
  sa: "SA",
};
